import React from 'react';

const SvgIconStep = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      fill="#919191"
      d="M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z"
    />
  </svg>
);

export default SvgIconStep;
